var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.lock)?[_c('active-detail',{attrs:{"activeLock":_vm.lock},on:{"changeStatus":_vm.detailHide}})]:_vm._e(),(_vm.lock)?[_c('turn-table',{on:{"getStatus":_vm.changeTable}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }